/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class CommissionField extends PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Field required>
        <label>Delivery Fee Rate</label>
        <Input
          label={{ content: '%' }}
          labelPosition="right"
          placeholder="e.g 25"
          type="number"
          min="0"
          max="50"
          required
          onChange={e => onChange('delivery_fee_rate', e.target.value)}
          value={value}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/feeRateField.js